import { createApiAction } from 'src/api';

export const FETCH_MESSAGES_START = 'message/fetch_messages_start';
export const FETCH_MESSAGES_SUCCESS = 'message/fetch_messages_success';
export const FETCH_MESSAGES_FAILURE = 'message/fetch_messages_failure';

export const fetchMessages = (financialInstitutionId, accountId) =>
  createApiAction(
    {
      path: `/api/v1/fis/${financialInstitutionId}/accounts/${accountId}/messages/`,
    },
    [FETCH_MESSAGES_START, FETCH_MESSAGES_SUCCESS, FETCH_MESSAGES_FAILURE]
  );
